import {HStack, Spinner, Text} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import {isOfferPreparationFailed, isOfferPreparing} from "@/utils/offerPreparation";

// Soft pastel pills (bg + matching dark text, no border) -- matches the status-pill style
// used everywhere else in the app (candidate lists, recruitment dashboard) instead of the
// harsh solid-color badges this used to render.
const STATUS_STYLES = {
    active: { bg: "#E4F7EC", color: "#178A4C" },
    draft: { bg: "#EAEAF2", color: "#65616F" },
};
const DEFAULT_STYLE = { bg: "#FDEFDC", color: "#B45309" };

export const RecruitmentStatusBadge = ({status, badgeStyles, preparationStatus, preparationProgress}) => {
    const { t } = useTranslation("jobOffer");
    const { t: tModels } = useTranslation("models");
    const offer = { preparationStatus };
    if (isOfferPreparing(offer) || isOfferPreparationFailed(offer)) {
        const failed = isOfferPreparationFailed(offer);
        return (
            <HStack
                as="span"
                display="inline-flex"
                gap={1.5}
                bg={failed ? "#FDE8E8" : "#EEE6FB"}
                color={failed ? "#B42318" : "#6B21A8"}
                fontSize="11.5px"
                fontWeight={600}
                px={3}
                py={1}
                borderRadius="999px"
                whiteSpace="nowrap"
                {...badgeStyles}
            >
                {!failed && <Spinner size="xs" />}
                {failed
                    ? tModels("offerPreparation.failed")
                    : tModels("offerPreparation.preparing", { progress: preparationProgress ?? 0 })}
            </HStack>
        );
    }
    const key = status?.toLowerCase();
    const { bg, color } = STATUS_STYLES[key] ?? DEFAULT_STYLE;
    const label = t(`enums.OFFER_STATUS.${key}`, t("enums.OFFER_STATUS.inactive"));

    return (
        <Text
            as="span"
            bg={bg}
            color={color}
            fontSize="11.5px"
            fontWeight={600}
            px={3}
            py={1}
            borderRadius="999px"
            whiteSpace="nowrap"
            {...badgeStyles}
        >
            {label}
        </Text>
    );
};